// Only code specific to this site should be here. Anything that can be used across multiple sites
// should be pushed into the KMS.
// const bootstrap = window.bootstrap;
import GLightbox from "glightbox";
import Splide from "@splidejs/splide";
// import { ProportionalImageNormalisation } from "./proportional-image-normalisation.js";

// import {FloatLabels} from "@keodesign/float-labels";


export function init() {
	// ProportionalImageNormalisation(".scale-me", 150, 0.525);

	scrollAnimation("section", ".fade-in-element");
	setupAccordion();
	setupAutoHideMenu();
	// new FloatLabels(".js-float-wrap");
	setupGallerySlider();
	setupGLightbox();
	initNavMenu();
	setupSlider();
	setupSingleSlider();
	setupSliderWithImage();
	const map_click = document.querySelectorAll(".map-click");
	if (map_click) {
		map_click.forEach(map_click => {
			map_click.addEventListener("click",() => {
				// shield the map on mobile for easy scrolling
				map_click.style.display = "none";
			});
		});
	}
}

export function setupGallerySlider(){
	const gallerySliders = document.querySelectorAll(".gallery-slider");
	gallerySliders.forEach(gallerySlider =>{
		new Splide( gallerySlider, {
			type   		: "slide",
			rewind    	: true,
			pagination	: false,
			arrows    	: false,
			perPage		: 3,
			padding		: "10%",
			gap			: "20px",
			breakpoints: {
				1400: {
					perPage: 2,
				
				},
				768: {
					perPage: 1,
				}
			}
		}).mount();
	});
}

function setupGLightbox(){
	const glightbox = GLightbox({
		touchNavigation: true,
		loop: true,
		autoplayVideos: true
	});

	// Parse query string
	const params = new URLSearchParams(window.location.search);
	const id = params.get("staff-id"); // e.g., ?id=123

	if (id) {
		// Find lightbox with matching data-id
		const lightbox = document.querySelector(`.glightbox[data-id="${id}"]`);
		glightbox.open(lightbox);
		// if (lightbox) {
		// 	lightbox.style.display = "block"; // Show the lightbox
		// }
	}

	// // Close button handler
	// document.querySelectorAll(".lightbox .close").forEach(btn => {
	// 	btn.addEventListener("click", function() {
	// 		this.closest(".lightbox").style.display = "none";
	// 	});
	// });
}

function setupAccordion(){

	const headers = document.querySelectorAll(".accordion-header");

	headers.forEach(header => {
		const toggleBody = () => {
			header.classList.toggle("closed");
			const body = header.nextElementSibling;
			const icon = header.querySelector("svg");
			header.classList.contains("closed") ?  body.style.maxHeight = "0px" : body.style.maxHeight = body.scrollHeight + "px";
			console.log(body.scrollHeight);
			icon.classList.toggle("rotate-180");
		};

		header.addEventListener("click", () => {
			toggleBody();
		});
		toggleBody();
	});

}



function initNavMenu() {
	// Mobile menu toggle
	const menuToggle = document.getElementById("menu-toggle");
	const navMenu = document.getElementById("nav-menu");

	if (menuToggle && navMenu) {
		menuToggle.addEventListener("click", () => {
			navMenu.classList.toggle("hidden");
		});
	}

	// Handle multiple dropdowns
	const dropdowns = document.querySelectorAll("[data-dropdown]");

	dropdowns.forEach(dropdown => {
		const toggle = dropdown.querySelector("[data-dropdown-toggle]");
		const menu = dropdown.querySelector("[data-dropdown-menu]");

		if (toggle && menu) {
			// Click toggle (mobile / accessibility)
			toggle.addEventListener("click", (e) => {
				e.stopPropagation();
				menu.classList.toggle("hidden");
			});

			// Mouse enter/leave (desktop hover)
			dropdown.addEventListener("mouseenter", (e) => {
				if (!dropdown.contains(e.relatedTarget)) {
					menu.classList.remove("hidden");
				}

			});
			dropdown.addEventListener("mouseleave", (e) => {
				if (!dropdown.contains(e.relatedTarget)) {
					menu.classList.add("hidden");
				}
			});

			// Close when clicking outside
			document.addEventListener("click", (e) => {
				if (!dropdown.contains(e.target)) {
					menu.classList.add("hidden");
				}
			});
		}
	});
  
}


export function adjustHeroPadding() {
	const header = document.getElementById("header-wrap");
	const hero = document.getElementById("splash-wrap");

	if (header && hero) {
		const headerHeight = header.offsetHeight; // get header height in px
		hero.style.paddingTop = headerHeight + "px";
	}
}

// Run again if window resizes (header height might change on responsive layouts)
window.addEventListener("resize", adjustHeroPadding);


export function isElementScrolledPast(el) {
	const rect = el.getBoundingClientRect();
	return rect.bottom < 0;
}


export function setupAutoHideMenu(){
	let lastScrollTop = 0;
	const navbar = document.querySelector("#navbar");

	navbar.style.top = "0px!important";
	// const toggler = splash_section.querySelector(".navbar-toggler-icon");
	// const logo_mobile = splash_section.querySelector("#logo-mobile");
	window.addEventListener("scroll", () => {
		let scrollTop = window.scrollY || document.documentElement.scrollTop;

		if (scrollTop > lastScrollTop) {
			// Scrolling down
			navbar.style.top = "-200px"; // Hide menu
		} else {
			// Scrolling up
			navbar.style.top = "0px";
		}
		lastScrollTop = scrollTop;
	});
}

export function setupLightbox(){
	GLightbox({
		plyr: {

			config: {
				ratio: "16:9", // or '4:3'
				muted: false,
				hideControls: true,
				youtube: {
					noCookie: true,
					rel: 0,
					showinfo: 0,
					iv_load_policy: 3
				},
				vimeo: {
					byline: false,
					portrait: false,
					title: true,
					speed: true,
					transparent: false
				}
			}
		}
	});

}


export function scrollAnimation(parentselector, selector) {
	const parentList = document.querySelectorAll(parentselector);
	parentList.forEach(parent => {
		const elements = parent.querySelectorAll(selector);
		let delay = 0;
		elements.forEach(el => {
			delay += 100;
			el.style.transitionDelay = `${delay}ms`;
		});

		const viewportHeight = window.innerHeight;
		const elHeight = parent.offsetHeight;

		// If element is taller than viewport, use a smaller threshold
		// Otherwise, stick with your default (0.5)
		const threshold = elHeight > viewportHeight ? 0.05 : 0.5;
		const observer = new IntersectionObserver((entries) => {	
			entries.forEach(entry => {
				if (entry.isIntersecting) {
					const target = entry.target;
					target.querySelectorAll(selector).forEach(el => el.classList.add("visible"));
					observer.unobserve(target);
				}
			});
		}, { threshold });

		observer.observe(parent);
	});
}




export function setupSlider(){
	var slider = document.querySelector(".slider");
	if (slider){
		new Splide( slider, {
			type   : "slide",
			rewind    : true,
			pagination: true,
			arrows    : true,
			autoplay: true,
			perPage: 3,
			perMove: 1,
			padding: 10,
			gap: "1rem"
		}).mount();
	}
}

export function setupSingleSlider(){
	var slider = document.querySelector(".single-slider");
	if (slider){
		new Splide( slider, {
			type   : "fade",
			rewind    : true,
			pagination: true,
			arrows    : false,
			autoplay: true,
			perPage: 1,
			perMove: 1,
		}).mount();
	}
}


export function setupSliderWithImage(){

	function updateGraphicFromSlide(slide, imageEl) {
		const graphicSpan = slide.querySelector("[data-graphic-url]");

		if (graphicSpan) {
			const url = graphicSpan.getAttribute("data-graphic-url");
			const alt = graphicSpan.getAttribute("data-graphic-name");

			// Check if an img already exists
			let img = imageEl.querySelector("img");

			if (!img) {
				// Create the image if it doesn't exist
				img = document.createElement("img");
				img.classList.add("w-full");
				img.classList.add("aspect-square");
				img.classList.add("rounded-[4rem]");
				imageEl.appendChild(img);
			}

			if (url && (img.src !== url)) {
				imageEl.classList.add("opacity-0");

				// Wait for fade-out to finish, then update src and fade back in
				setTimeout(() => {
					img.src = url;
					if (alt){
						img.alt = alt;
					}
					// Once image loads, fade it back in
					img.onload = () => {
						imageEl.classList.remove("opacity-0");
					};
				}, 500); // shorter than transition time for a smoother effect
			}
		} else {
			// Optional: remove img if no graphic is found
			const existingImg = imageEl.querySelector("img");
			if (existingImg) {
				imageEl.classList.add("fade-out");
				setTimeout(() => {
					imageEl.classList.remove("fade-out");
					imageEl.removeChild(existingImg);
				}, 500);
			
			}
		}

		
	}

	const Slider = document.querySelectorAll(".block-content-slider");
	
	if(Slider){
		for (var i = 0; i < Slider.length; i++ ) {
			var slider = Slider[i].querySelector(".content-slider");
			if (!slider){
				continue;
			}
			const splide = new Splide( slider, {
				type   : "slide",
				rewind    : true,
				pagination: false,
				arrows    : true,
				autoplay: true,
				perPage: 1,
				perMove: 1,
			});

			const imageEl = Slider[i].querySelector(".graphic-image-container");
			// Update on mount
			splide.on("mounted", () => {
				const currentSlide = splide.Components.Slides.getAt(splide.index).slide;
				updateGraphicFromSlide(currentSlide, imageEl);
			});

			// Update on slide change
			splide.on("move", (newIndex) => {
				const newSlide = splide.Components.Slides.getAt(newIndex).slide;
				updateGraphicFromSlide(newSlide, imageEl);
			});

			splide.mount();
		}
	}

	
}
window.addEventListener("DOMContentLoaded", init);